import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  CircularProgress,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  Paper,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { AuthContext } from "../context/AuthContext";
import {
  postBakiciAdd,
  putBakiciUpdate,
  getUlkeKodlari,
  getTanimEgitimDurumu,
  getIllerForRegister,
  getIlcelerForRegister,
  getBakiciInfo, // ← Bunu ekle
} from "../services/api";

const orangeColor = "#FF7A2B";
const orangeHoverColor = "#F57C00";

const BakiciFormModal = ({ open, onClose, bakici, onSuccess }) => {
  const { token } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [ureticiId, setUreticiId] = useState(null);

  // Telefon formatı fonksiyonları - YENİ
  const formatPhoneNumber = (value) => {
    let cleaned = value.replace(/\D/g, "");

    // Eğer 0 ile başlamıyorsa ekle
    if (cleaned.length > 0 && cleaned[0] !== "0") {
      cleaned = "0" + cleaned;
    }

    // İlk 11 haneyi al
    cleaned = cleaned.substring(0, 11);

    const match = cleaned.match(/^(\d{0,4})(\d{0,3})(\d{0,4})$/);

    if (match) {
      const formatted = [
        match[1] ? `(${match[1]})` : "",
        match[2] ? ` ${match[2]}` : "",
        match[3] ? ` ${match[3]}` : "",
      ].join("");

      return formatted.trim();
    }

    return value;
  };

  const unformatPhoneNumber = (value) => {
    // Sadece rakamları döndür (backend'e gönderilecek)
    return value.replace(/\D/g, "");
  };

  // Ad ve Soyad formatı fonksiyonları - YENİ
  const formatAd = (value) => {
    // Her kelimenin ilk harfini büyük yap
    return value
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatSoyad = (value) => {
    // Tüm harfleri büyük yap
    return value.toUpperCase();
  };

  // Hata state'i ekle
  const [errors, setErrors] = useState({
    BAKICI_ADI: false,
    BAKICI_SOYADI: false,
    TCKN: false,
    EVLIMI: false,
    CINSIYET: false,
  });

  // Form state'i - Backend'e gönderilecek alan adları ile
  const [formData, setFormData] = useState({
    BAKICI_ID: "", // ← EKLENDİ
    KULLANICI_ID: "", // ← EKLENDİ
    URETICI_ID: 1,
    BAKICI_ADI: "",
    BAKICI_SOYADI: "",
    TCKN: "",
    TEL1: "",
    DOGUM_TARIHI: "",
    UYRUK_ULKE_ID: "",
    EGITIM_DURUMU_ID: "",
    DOGUM_IL_ID: "",
    DOGUM_ILCE_ID: "",
    EVLIMI: "",
    COCUK_SAYISI: "",
    CINSIYET: "",
  });

  const [ulkeler, setUlkeler] = useState([]);
  const [egitimDurumlari, setEgitimDurumlari] = useState([]);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  const fetchUreticiId = async () => {
    if (!token) return null;

    try {
      // console.log("Modal: Üretici ID alınıyor...");
      const response = await getBakiciInfo();
      let bakiciBilgisi = response.data?.data || response.data || {};

      if (Array.isArray(bakiciBilgisi) && bakiciBilgisi.length > 0) {
        bakiciBilgisi = bakiciBilgisi[0];
      }

      const fetchedUreticiId = bakiciBilgisi?.URETICI_ID || null;
      // console.log("Modal: Alınan URETICI_ID:", fetchedUreticiId);

      setUreticiId(fetchedUreticiId);
      return fetchedUreticiId;
    } catch (error) {
      // console.error("Modal: Üretici ID alma hatası:", error);
      return null;
    }
  };

  // Dropdown verilerini yükle
  const loadDropdownData = async () => {
    setDropdownLoading(true);
    try {
      // console.log("=== DROPDOWN VERİLERİ YÜKLENİYOR ===");

      const [ulkeRes, egitimRes, ilRes] = await Promise.all([
        getUlkeKodlari(),
        getTanimEgitimDurumu(),
        getIllerForRegister(),
      ]);

      // console.log("Ülkeler Response:", ulkeRes.data);
      // console.log("Eğitim Response:", egitimRes.data);
      // console.log("İller Response:", ilRes.data);

      // API response'larından veri çıkarma
      const ulkeData = ulkeRes.data?.data || ulkeRes.data || [];
      const egitimData = egitimRes.data?.data || egitimRes.data || [];
      const ilData = ilRes.data?.data || ilRes.data || [];

      setUlkeler(Array.isArray(ulkeData) ? ulkeData : []);
      setEgitimDurumlari(Array.isArray(egitimData) ? egitimData : []);
      setIller(Array.isArray(ilData) ? ilData : []);

      // console.log("Dropdown verileri set edildi");
    } catch (error) {
      // console.error("Dropdown yükleme hatası:", error);
      enqueueSnackbar(
        "Form verileri yüklenirken hata oluştu: " + error.message,
        {
          variant: "error",
        }
      );
    } finally {
      setDropdownLoading(false);
    }
  };

  // İl değiştiğinde ilçeleri yükle
  const handleIlChange = async (ilId) => {
    setFormData((prev) => ({ ...prev, DOGUM_IL_ID: ilId, DOGUM_ILCE_ID: "" }));

    if (ilId) {
      try {
        // console.log("İlçeler yükleniyor, İl ID:", ilId);
        const response = await getIlcelerForRegister(ilId);
        const ilceData = response.data?.data || response.data || [];
        setIlceler(Array.isArray(ilceData) ? ilceData : []);
      } catch (error) {
        // console.error("İlçe yükleme hatası:", error);
        enqueueSnackbar("İlçeler yüklenirken hata oluştu: " + error.message, {
          variant: "error",
        });
      }
    } else {
      setIlceler([]);
    }
  };

  useEffect(() => {
    if (open) {
      // console.log("Modal açıldı, veriler yükleniyor...");

      // Üretici ID'yi al
      fetchUreticiId();

      // Dropdown verilerini yükle
      loadDropdownData();

      if (bakici) {
        // console.log("=== MEVCUT BAKICI VERİLERİ ===");
        // console.log("Bakıcı objesi:", bakici);
        // console.log("BAKICI_ID:", bakici.BAKICI_ID);
        // console.log("BAKICI_KULLANICI_ID:", bakici.BAKICI_KULLANICI_ID);
        // console.log("KULLANICI_ID:", bakici.KULLANICI_ID);
        // KULLANICI_ID'yi belirle
        const kullaniciId = bakici.BAKICI_KULLANICI_ID || bakici.KULLANICI_ID;
        // console.log("Kullanılacak KULLANICI_ID:", kullaniciId);

        if (!kullaniciId) {
          // console.error("KULLANICI_ID bulunamadı!");
          enqueueSnackbar("Bakıcı kullanıcı ID bilgisi eksik", {
            variant: "error",
          });
          return;
        }

        // Tarih formatını dönüştür
        let formattedDate = "";
        if (bakici.DOGUM_TARIHI) {
          // Eğer object ise {year, month, day}
          if (
            typeof bakici.DOGUM_TARIHI === "object" &&
            bakici.DOGUM_TARIHI.year
          ) {
            const day = String(bakici.DOGUM_TARIHI.day).padStart(2, "0");
            const month = String(bakici.DOGUM_TARIHI.month).padStart(2, "0");
            const year = bakici.DOGUM_TARIHI.year;
            formattedDate = `${year}-${month}-${day}`;
          }
          // Eğer "15.08.1994" formatındaysa
          else if (String(bakici.DOGUM_TARIHI).includes(".")) {
            const [day, month, year] = bakici.DOGUM_TARIHI.split(".");
            formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
              2,
              "0"
            )}`;
          }
          // Eğer ISO formatındaysa (2024-08-15T00:00:00)
          else if (String(bakici.DOGUM_TARIHI).includes("T")) {
            formattedDate = bakici.DOGUM_TARIHI.split("T")[0];
          }
          // Eğer zaten doğru formattaysa
          else {
            formattedDate = String(bakici.DOGUM_TARIHI);
          }
        }

        // console.log("Bakıcı orijinal tarih:", bakici.DOGUM_TARIHI);
        // console.log("Formatlanmış tarih:", formattedDate);

        // Düzenleme modu - mevcut bakıcı verilerini doldur
        setFormData({
          BAKICI_ID: bakici.BAKICI_ID,
          KULLANICI_ID: kullaniciId, // ← Belirlenen KULLANICI_ID'yi kullan
          BAKICI_ADI: bakici.BAKICI_ADI || "",
          BAKICI_SOYADI: bakici.BAKICI_SOYADI || "",
          TCKN: bakici.TCKN || "",
          TEL1: bakici.TEL1 || bakici.KULLANICI_TEL_NO || bakici.TELEFON || "",
          DOGUM_TARIHI: formattedDate,
          UYRUK_ULKE_ID: bakici.UYRUK_ULKE_ID || "",
          EGITIM_DURUMU_ID: bakici.EGITIM_DURUMU_ID || "",
          DOGUM_IL_ID: bakici.DOGUM_IL_ID || "",
          DOGUM_ILCE_ID: bakici.DOGUM_ILCE_ID || "",
          EVLIMI: bakici.EVLIMI || "",
          COCUK_SAYISI: bakici.COCUK_SAYISI || "",
          CINSIYET: bakici.CINSIYET || "",
        });

        if (bakici.DOGUM_IL_ID) {
          handleIlChange(bakici.DOGUM_IL_ID);
        }
      } else {
        // Yeni ekleme modu - formu temizle
        setFormData({
          BAKICI_ID: "", // ← bakici null olduğu için boş string
          KULLANICI_ID: "",
          BAKICI_ADI: "",
          BAKICI_SOYADI: "",
          TCKN: "",
          TEL1: "",
          DOGUM_TARIHI: "",
          UYRUK_ULKE_ID: "",
          EGITIM_DURUMU_ID: "",
          DOGUM_IL_ID: "",
          DOGUM_ILCE_ID: "",
          EVLIMI: "",
          COCUK_SAYISI: "",
          CINSIYET: "",
        });
        setIlceler([]);
      }
    }
  }, [open, bakici]);

  // Form gönder - GÜNCELLENMIŞ
  const handleSubmit = async () => {
    // console.log("=== FORM GÖNDER DEBUG ===");

    // Hata state'ini sıfırla
    const newErrors = {
      BAKICI_ADI: false,
      BAKICI_SOYADI: false,
      TCKN: false,
      EVLIMI: false,
    };

    // Validasyon ve hataları işaretle
    let hasError = false;

    if (!formData.BAKICI_ADI?.trim()) {
      newErrors.BAKICI_ADI = true;
      hasError = true;
    }

    if (!formData.BAKICI_SOYADI?.trim()) {
      newErrors.BAKICI_SOYADI = true;
      hasError = true;
    }

    if (!formData.TCKN?.trim()) {
      newErrors.TCKN = true;
      hasError = true;
    }

    if (!formData.EVLIMI) {
      newErrors.EVLIMI = true;
      hasError = true;
    }

    if (!formData.CINSIYET) {
      // ← Ekle
      newErrors.CINSIYET = true;
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) {
      enqueueSnackbar("Lütfen zorunlu alanları doldurun", {
        variant: "warning",
      });
      return;
    }

    // Üretici ID kontrolü - YENİ EKLENEN
    if (!ureticiId) {
      enqueueSnackbar("Üretici bilgisi alınamadı, lütfen sayfayı yenileyin", {
        variant: "error",
      });
      return;
    }

    // console.log("Validasyon geçti");
    // console.log("Kullanılacak Üretici ID:", ureticiId);

    setLoading(true);
    try {
      // Tarih formatını dönüştür: YYYY-MM-DD -> DD.MM.YYYY
      let formattedDate = "";
      if (formData.DOGUM_TARIHI) {
        const [year, month, day] = formData.DOGUM_TARIHI.split("-");
        formattedDate = `${day}-${month}-${year}`; // ← Nokta yerine tire kullan
      }

      // console.log("Orijinal tarih:", formData.DOGUM_TARIHI);
      // console.log("Formatlanmış tarih:", formattedDate);

      const submitData = {
        URETICI_ID: ureticiId,
        BAKICI_ADI: formData.BAKICI_ADI.trim(),
        BAKICI_SOYADI: formData.BAKICI_SOYADI.trim(),
        TCKN: formData.TCKN.trim(),
        TEL1: formData.TEL1.trim(), // ← KULLANICI_TEL_NO yerine TEL1
        EVLIMI: formData.EVLIMI,
        CINSIYET: formData.CINSIYET,
        COCUK_SAYISI: formData.COCUK_SAYISI
          ? parseInt(formData.COCUK_SAYISI)
          : 0,
        UYRUK_ULKE_ID: formData.UYRUK_ULKE_ID
          ? parseInt(formData.UYRUK_ULKE_ID)
          : 0,
        DOGUM_TARIHI: formattedDate,
        DOGUM_IL_ID: formData.DOGUM_IL_ID ? parseInt(formData.DOGUM_IL_ID) : 0,
        DOGUM_ILCE_ID: formData.DOGUM_ILCE_ID
          ? parseInt(formData.DOGUM_ILCE_ID)
          : 0,
        EGITIM_DURUMU_ID: formData.EGITIM_DURUMU_ID
          ? parseInt(formData.EGITIM_DURUMU_ID)
          : 0,
      };

      // console.log("Submit Data:", submitData);

      if (bakici) {
        // Düzenleme modu - GÜNCELLEME
        const updateData = {
          KULLANICI_ID: bakici.BAKICI_KULLANICI_ID || bakici.KULLANICI_ID, // ← Bu alanın dolu olduğundan emin ol
          URETICI_ID: ureticiId,
          BAKICI_ADI: formData.BAKICI_ADI.trim(),
          BAKICI_SOYADI: formData.BAKICI_SOYADI.trim(),
          TCKN: formData.TCKN.trim(),
          TEL1: formData.TEL1.trim(),
          EVLIMI: formData.EVLIMI,
          CINSIYET: formData.CINSIYET,
          COCUK_SAYISI: formData.COCUK_SAYISI
            ? parseInt(formData.COCUK_SAYISI)
            : 0,
          UYRUK_ULKE_ID: formData.UYRUK_ULKE_ID
            ? parseInt(formData.UYRUK_ULKE_ID)
            : 0,
          DOGUM_TARIHI: formattedDate,
          DOGUM_IL_ID: formData.DOGUM_IL_ID
            ? parseInt(formData.DOGUM_IL_ID)
            : 0,
          DOGUM_ILCE_ID: formData.DOGUM_ILCE_ID
            ? parseInt(formData.DOGUM_ILCE_ID)
            : 0,
          EGITIM_DURUMU_ID: formData.EGITIM_DURUMU_ID
            ? parseInt(formData.EGITIM_DURUMU_ID)
            : 0,
        };

        // KULLANICI_ID kontrolü ekle
        if (!updateData.KULLANICI_ID) {
          enqueueSnackbar(
            "Kullanıcı ID bilgisi eksik, lütfen sayfayı yenileyin",
            {
              variant: "error",
            }
          );
          return;
        }

        // console.log("Güncelleme Data:", updateData);
        // console.log("KULLANICI_ID:", updateData.KULLANICI_ID);

        const response = await putBakiciUpdate(updateData);
        // console.log("Güncelleme Response:", response);

        enqueueSnackbar("Bakıcı başarıyla güncellendi!", {
          variant: "success",
        });
        onSuccess();
      } else {
        // Yeni ekleme modu
        const response = await postBakiciAdd(submitData);
        // console.log("API Response:", response);

        enqueueSnackbar("Bakıcı başarıyla eklendi!", { variant: "success" });
        onSuccess();
      }
    } catch (error) {
      // console.error("=== HATA DETAYLARI ===");
      // console.error("Error:", error);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data?.data ||
        error.message ||
        "Bakıcı kaydedilirken hata oluştu";

      enqueueSnackbar(errorMessage, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    // Kullanıcı yazmaya başladığında hatayı temizle
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: false }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: "70vh",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          backgroundColor: orangeColor,
          color: "white",
          textAlign: "center",
          fontSize: "1.5rem",
          fontWeight: "bold",
          py: 2,
        }}
      >
        {bakici ? "Bakıcı Bilgilerini Düzenle" : "Yeni Bakıcı Ekle"}
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {dropdownLoading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 400,
            }}
          >
            <CircularProgress size={50} sx={{ color: orangeColor, mb: 2 }} />
            <Typography variant="h6" color="text.secondary">
              Form verileri yükleniyor...
            </Typography>
          </Box>
        ) : (
          <Box sx={{ p: 1 }}>
            {/* Kişisel Bilgiler Bölümü - GÜNCELLENMIŞ */}
            <Paper
              elevation={1}
              sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: orangeColor,
                  fontWeight: "bold",
                  borderBottom: `2px solid ${orangeColor}`,
                  pb: 1,
                }}
              >
                📋 Kişisel Bilgiler
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Ad *"
                    fullWidth
                    required
                    error={errors.BAKICI_ADI}
                    helperText={errors.BAKICI_ADI ? "Ad alanı zorunludur" : ""}
                    value={formData.BAKICI_ADI}
                    onChange={(e) => {
                      const formatted = formatAd(e.target.value);
                      handleInputChange("BAKICI_ADI", formatted);
                    }}
                    variant="outlined"
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-error": {
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Soyad *"
                    fullWidth
                    required
                    error={errors.BAKICI_SOYADI}
                    helperText={
                      errors.BAKICI_SOYADI ? "Soyad alanı zorunludur" : ""
                    }
                    value={formData.BAKICI_SOYADI}
                    onChange={(e) => {
                      const formatted = formatSoyad(e.target.value);
                      handleInputChange("BAKICI_SOYADI", formatted);
                    }}
                    variant="outlined"
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-error": {
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="TCKN *"
                    fullWidth
                    required
                    error={errors.TCKN}
                    helperText={errors.TCKN ? "TCKN alanı zorunludur" : ""}
                    value={formData.TCKN}
                    onChange={(e) => handleInputChange("TCKN", e.target.value)}
                    inputProps={{ maxLength: 11 }}
                    variant="outlined"
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-error": {
                          "& fieldset": {
                            borderColor: "#d32f2f",
                            borderWidth: "2px",
                          },
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Telefon"
                    fullWidth
                    value={formatPhoneNumber(formData.TEL1)}
                    onChange={(e) => {
                      const unformatted = unformatPhoneNumber(e.target.value);
                      handleInputChange("TEL1", unformatted);
                    }}
                    placeholder="(0XXX) XXX XXXX"
                    inputProps={{ maxLength: 17 }}
                    variant="outlined"
                    sx={{ backgroundColor: "white" }}
                    helperText="11 haneli telefon numaranızı girin"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Doğum Tarihi"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.DOGUM_TARIHI}
                    onChange={(e) =>
                      handleInputChange("DOGUM_TARIHI", e.target.value)
                    }
                    variant="outlined"
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* Uyruk ve Eğitim Bölümü - aynı kalacak */}
            <Paper
              elevation={1}
              sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: orangeColor,
                  fontWeight: "bold",
                  borderBottom: `2px solid ${orangeColor}`,
                  pb: 1,
                }}
              >
                🎓 Uyruk ve Eğitim Bilgileri
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    sx={{
                      backgroundColor: "white",
                      minWidth: 260,
                    }}
                  >
                    <InputLabel
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 500,
                      }}
                    >
                      Uyruk
                    </InputLabel>
                    <Select
                      value={formData.UYRUK_ULKE_ID}
                      label="Uyruk"
                      onChange={(e) =>
                        handleInputChange("UYRUK_ULKE_ID", e.target.value)
                      }
                      sx={{
                        minHeight: 56,
                        "& .MuiSelect-select": {
                          padding: "16px 14px",
                          fontSize: "1rem",
                          lineHeight: "1.5",
                        },
                      }}
                    >
                      <MenuItem value="">Seçiniz</MenuItem>
                      {ulkeler.map((ulke) => (
                        <MenuItem
                          key={ulke.ULKE_ID}
                          value={ulke.ULKE_ID}
                          sx={{
                            fontSize: "1rem",
                            padding: "12px 16px",
                          }}
                        >
                          {ulke.ULKEADI}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    sx={{
                      backgroundColor: "white",
                      minWidth: 260,
                    }}
                  >
                    <InputLabel
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 500,
                      }}
                    >
                      Eğitim Durumu
                    </InputLabel>
                    <Select
                      value={formData.EGITIM_DURUMU_ID}
                      label="Eğitim Durumu"
                      onChange={(e) =>
                        handleInputChange("EGITIM_DURUMU_ID", e.target.value)
                      }
                      sx={{
                        minHeight: 56,
                        "& .MuiSelect-select": {
                          padding: "16px 14px",
                          fontSize: "1rem",
                          lineHeight: "1.5",
                        },
                      }}
                    >
                      <MenuItem value="">Seçiniz</MenuItem>
                      {egitimDurumlari.map((egitim) => (
                        <MenuItem
                          key={egitim.EGITIM_DURUMU_ID}
                          value={egitim.EGITIM_DURUMU_ID}
                          sx={{
                            fontSize: "1rem",
                            padding: "12px 16px",
                          }}
                        >
                          {egitim.EGITIM_DURUMU_NAME}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>

            {/* Doğum Yeri Bölümü - aynı kalacak */}
            {formData.UYRUK_ULKE_ID === 168 ? (
              <Paper
                elevation={1}
                sx={{ p: 3, mb: 3, backgroundColor: "#f9f9f9" }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    color: orangeColor,
                    fontWeight: "bold",
                    borderBottom: `2px solid ${orangeColor}`,
                    pb: 1,
                  }}
                >
                  📍 Doğum Yeri
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        backgroundColor: "white",
                        minHeight: 56,
                      }}
                    >
                      <InputLabel
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        Doğduğu İl
                      </InputLabel>
                      <Select
                        value={formData.DOGUM_IL_ID}
                        label="Doğduğu İl"
                        onChange={(e) => {
                          handleIlChange(e.target.value);
                          // console.log(e.target.value);
                        }}
                        sx={{
                          minHeight: 56,
                          "& .MuiSelect-select": {
                            padding: "16px 14px",
                            fontSize: "1rem",
                            lineHeight: "1.5",
                          },
                        }}
                      >
                        <MenuItem value="">Seçiniz</MenuItem>
                        {iller.map((il) => (
                          <MenuItem
                            key={il.IL_ID}
                            value={il.IL_ID}
                            sx={{
                              fontSize: "1rem",
                              padding: "12px 16px",
                            }}
                          >
                            {il.IL_ADI}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl
                      fullWidth
                      disabled={!formData.DOGUM_IL_ID}
                      sx={{
                        backgroundColor: formData.DOGUM_IL_ID
                          ? "white"
                          : "#f5f5f5",
                        minHeight: 56,
                      }}
                    >
                      <InputLabel
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 500,
                        }}
                      >
                        Doğduğu İlçe
                      </InputLabel>
                      <Select
                        value={formData.DOGUM_ILCE_ID}
                        label="Doğduğu İlçe"
                        onChange={(e) =>
                          handleInputChange("DOGUM_ILCE_ID", e.target.value)
                        }
                        sx={{
                          minHeight: 56,
                          "& .MuiSelect-select": {
                            padding: "16px 14px",
                            fontSize: "1rem",
                            lineHeight: "1.5",
                          },
                        }}
                      >
                        <MenuItem value="">Seçiniz</MenuItem>
                        {ilceler.map((ilce) => (
                          <MenuItem
                            key={ilce.ILCE_ID}
                            value={ilce.ILCE_ID}
                            sx={{
                              fontSize: "1rem",
                              padding: "12px 16px",
                            }}
                          >
                            {ilce.ILCE_ADI}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            ) : null}

            {/* Aile Bilgileri Bölümü - GÜNCELLENMIŞ */}
            <Paper elevation={1} sx={{ p: 3, backgroundColor: "#f9f9f9" }}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: orangeColor,
                  fontWeight: "bold",
                  borderBottom: `2px solid ${orangeColor}`,
                  pb: 1,
                }}
              >
                👨‍👩‍👧‍👦 Aile Bilgileri
              </Typography>

              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      backgroundColor: "white",
                      p: 2,
                      borderRadius: 1,
                      border: errors.CINSIYET ? "2px solid #d32f2f" : "none",
                      boxShadow: errors.CINSIYET
                        ? "0 0 0 0.2rem rgba(211, 47, 47, 0.25)"
                        : "none",
                    }}
                  >
                    <FormControl component="fieldset" error={errors.CINSIYET}>
                      <FormLabel
                        component="legend"
                        sx={{
                          color: errors.CINSIYET ? "#d32f2f" : orangeColor,
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        Cinsiyet *
                      </FormLabel>
                      <RadioGroup
                        row
                        value={formData.CINSIYET}
                        onChange={(e) =>
                          handleInputChange("CINSIYET", e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="K"
                          control={
                            <Radio
                              sx={{
                                color: errors.CINSIYET
                                  ? "#d32f2f"
                                  : orangeColor,
                              }}
                            />
                          }
                          label="Kadın"
                        />
                        <FormControlLabel
                          value="E"
                          control={
                            <Radio
                              sx={{
                                color: errors.CINSIYET
                                  ? "#d32f2f"
                                  : orangeColor,
                              }}
                            />
                          }
                          label="Erkek"
                        />
                        <FormControlLabel
                          value="B"
                          control={
                            <Radio
                              sx={{
                                color: errors.CINSIYET
                                  ? "#d32f2f"
                                  : orangeColor,
                              }}
                            />
                          }
                          label="Belirtmek İstemiyorum"
                        />
                      </RadioGroup>
                      {errors.CINSIYET && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ mt: 0.5 }}
                        >
                          Cinsiyet alanı zorunludur
                        </Typography>
                      )}
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      backgroundColor: "white",
                      p: 2,
                      borderRadius: 1,
                      border: errors.EVLIMI ? "2px solid #d32f2f" : "none",
                      boxShadow: errors.EVLIMI
                        ? "0 0 0 0.2rem rgba(211, 47, 47, 0.25)"
                        : "none",
                    }}
                  >
                    <FormControl component="fieldset" error={errors.EVLIMI}>
                      <FormLabel
                        component="legend"
                        sx={{
                          color: errors.EVLIMI ? "#d32f2f" : orangeColor,
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        Medeni Durum *
                      </FormLabel>
                      <RadioGroup
                        row
                        value={formData.EVLIMI}
                        onChange={(e) =>
                          handleInputChange("EVLIMI", e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="E"
                          control={
                            <Radio
                              sx={{
                                color: errors.EVLIMI ? "#d32f2f" : orangeColor,
                              }}
                            />
                          }
                          label="Evli"
                        />
                        <FormControlLabel
                          value="H"
                          control={
                            <Radio
                              sx={{
                                color: errors.EVLIMI ? "#d32f2f" : orangeColor,
                              }}
                            />
                          }
                          label="Bekar"
                        />
                      </RadioGroup>
                      {errors.EVLIMI && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{ mt: 0.5 }}
                        >
                          Medeni durum alanı zorunludur
                        </Typography>
                      )}
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Çocuk Sayısı"
                    type="number"
                    fullWidth
                    value={formData.COCUK_SAYISI}
                    onChange={(e) =>
                      handleInputChange("COCUK_SAYISI", e.target.value)
                    }
                    helperText="Çocuğu yoksa boş bırakabilirsiniz"
                    inputProps={{ min: 0, max: 20 }}
                    variant="outlined"
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )}
      </DialogContent>

      {/* Footer Buttons - aynı */}
      <DialogActions
        sx={{
          p: 3,
          backgroundColor: "#f5f5f5",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          size="large"
          sx={{
            borderColor: "#ccc",
            color: "#666",
            minWidth: 120,
          }}
        >
          İptal
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || dropdownLoading}
          size="large"
          sx={{
            backgroundColor: orangeColor,
            "&:hover": { backgroundColor: orangeHoverColor },
            minWidth: 120,
            py: 1.5,
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
              Kaydediliyor...
            </>
          ) : bakici ? (
            "Güncelle"
          ) : (
            "Kaydet"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BakiciFormModal;
